/**
 * Created by hcq on 2023/12/27.
 */
import axios from "axios";
import { AiToolLink } from "@/utils/config";
import useUserStore from "@/stores/user";
import { getToken, setToken } from "@/utils/login";
import { ApiUser } from "@/api/login";


const service = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API,
  timeout: 60000,
  // withCredentials: false,
  headers: {
    "Content-Type": "application/json",
    // 'token': '',
    "X-Requested-With": "XMLHttpRequest",
    // Authorization: getToken(),
  },
});
// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    config.headers["Authorization"] = getToken();
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // console.log("拦截器response", response);
    if (response.data && response.data?.code === 401) {
      console.log("登录失败");
      
      const userStore = useUserStore();
      
      if(window.location.href.indexOf('LtpaToken') !== -1){
        // url假设是http://localhost:5173/?LtpaToken=123#/ 
        const params = new URLSearchParams(window.location.search);
        let token = params.get('LtpaToken');
        console.log('token1', token)
        if (token) {
          ApiUser.postOATokenLogin({
            token,
          }).then(res=>{
            setToken(res.data.sessionId);
            userStore.setup();
            ElMessage.success("登录成功");
          }).catch(err=>{
           
          })
        }
      }
      else{
        console.log("99999");
        userStore.logout();
        if(window.location.href.indexOf('userAgreement') !== -1){
          userStore.dialogLogin = false;
        }else{
          
          userStore.login();
        }
      }
      

    }
    if (response.data && response.data?.code === 2002) {
      ElMessage({
        showClose: true,
        message: "算力余额不足，请联系平台管理员",
        type: "warning",
      });
      return Promise.reject("算力余额不足，请联系平台管理员");
    } else {
      const dataAxios = response.data;
      return dataAxios;
    }
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    // console.log('拦截器error', error)
    return Promise.reject(error);
  }
);

export default service;
